module.exports = __webpack_public_path__ + "static/media/30_July_2022_EV_state_leadership_Delhi_Award.f60596ca.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/30_July_2022_EV_state_leadership_Delhi_Award.webp
// module id = 303
// module chunks = 0